import React, { useEffect, useState }  from 'react';
import './Skill.css';


const Skill = ({ sendSpellInfoToInterface, name, pp, fullPP, power, accuracy, type, description, playerName }) => {

    const [changedName, setChangedName] = useState("");

    useEffect(() => {
        setChangedName(capitalizeSpellName(name));
    }, [])

    const capitalizeSpellName = (name) => {
        let splittedName = name.split("-");
        splittedName = splittedName.map(part => part.slice(0, 1).toUpperCase().concat(part.slice(1)));
        return splittedName.join(" ");
    }

    const sendSkillInfo = () => {
        const desc = description;
        const spellInfo = {
            text: `${changedName}: ${desc}`,
            info : {
                power,
                type,
                accuracy,
                pp,
                name,
                playerName
            }
        }
        sendSpellInfoToInterface(spellInfo);
    }

    return (
        <div className="skill" onClick={sendSkillInfo}>
            <div className="skill-name">{changedName}</div>
            <div className="skill-pp">PP: {pp}/{fullPP}</div>
        </div>
    );
} 

export default Skill;